import { object, string } from '@/_config/lib/yup';
import type { InferType } from '@/_config/lib/yup';

export const PLACES_PRE_REGISTRATION_ADDRESS_AUTOCOMPLETE_ID =
  'places-pre-registration-address-autocomplete';

export const GOOGLE_ADDRESS_TYPES = {
  cidade: 'administrative_area_level_2',
  numero: 'street_number',
  endereco: 'route',
  bairro: 'sublocality_level_1',
  cep: 'postal_code',
};

export const GOOGLE_SUBURB_LIKE_TYPES = [
  'neighborhood',
  'sublocality_level_1',
  'sublocality_level_2',
  'sublocality',
];

export const PLACES_PRE_REGISTRATION_FORM_SCHEMA = object({
  endereco: string().required(),
  logradouro: string().required('Logradouro é obrigatório'),
  numero: string().required('Número é obrigatório'),
  bairro: string().optional(),
  cep: string().required(),
  cityName: string().required(),
  neighborhoodId: string().optional(),
  complemento: string().optional(),
  referencia: string().optional(),
}).test(
  'neighborhood-required',
  'Bairro é obrigatório',
  function validateNeighborhood(values) {
    if (values.neighborhoodId?.trim() || values.bairro?.trim()) {
      return true;
    }

    return this.createError({
      path: 'neighborhoodId',
      message: 'Bairro é obrigatório',
    });
  },
);

export type PlacesPreRegistrationFormValues = InferType<
  typeof PLACES_PRE_REGISTRATION_FORM_SCHEMA
>;

interface GoogleAddressComponent {
  long_name: string;
  types: readonly string[];
}

export interface GooglePlace {
  formatted_address?: string;
  address_components?: GoogleAddressComponent[];
  geometry?: {
    location: {
      lat(): number;
      lng(): number;
    };
  };
}

export function getSuburbFromGoogleComponents(
  addressComponents: GooglePlace['address_components'],
): string | undefined {
  if (!addressComponents?.length) return undefined;

  return GOOGLE_SUBURB_LIKE_TYPES.reduce<string | undefined>((acc, type) => {
    if (acc) return acc;
    const component = addressComponents.find(c => c.types.includes(type));
    return component?.long_name?.trim() || undefined;
  }, undefined);
}

export function findDropdownOptionBySuburbName<
  T extends { text: string; value: string },
>(suburbName: string, options: T[]): T | undefined {
  const normalizedSuburb = suburbName.trim().toLowerCase();
  if (!normalizedSuburb) return undefined;

  const exactMatch = options.find(
    option => option.text.trim().toLowerCase() === normalizedSuburb,
  );
  if (exactMatch) return exactMatch;

  return options.find(
    option =>
      option.text.trim().toLowerCase().includes(normalizedSuburb) ||
      normalizedSuburb.includes(option.text.trim().toLowerCase()),
  );
}
